export function EmbedIcon() {
  return (
    <svg width='40' height='40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20Z'
        fill='#B2B2CC'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.474 16.124a.841.841 0 0 1-.044 1.189l-2.88 2.674 2.88 2.674a.841.841 0 0 1-1.145 1.232l-3.543-3.29a.841.841 0 0 1 0-1.233l3.543-3.29a.841.841 0 0 1 1.189.044ZM23.342 23.85a.841.841 0 0 1 .044-1.189l2.88-2.674-2.88-2.674a.841.841 0 1 1 1.144-1.233l3.544 3.29a.841.841 0 0 1 0 1.233l-3.544 3.29a.841.841 0 0 1-1.188-.043Z'
        fill='#fff'
      />
    </svg>
  )
}

export function QrCodeIcon() {
  return (
    <svg width='40' height='40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20Z'
        fill='#F15D1E'
      />
      <g clipPath='url(#a)' fill='#fff'>
        <path d='M12.5 13.334v4.828h4.828v-4.828H12.5Zm3.692 3.692h-2.556V14.47h2.556v2.556Z' />
        <path d='M15.482 15.18h-1.136v1.136h1.136V15.18ZM22.213 13.334v4.828h4.828v-4.828h-4.828Zm3.692 3.692H23.35V14.47h2.556v2.556Z' />
        <path d='M25.195 15.18H24.06v1.136h1.136V15.18ZM12.5 23.048v4.828h4.828v-4.828h-4.829Zm3.692 3.692h-2.556v-2.556h2.556v2.556Z' />
        <path d='M15.482 24.894h-1.136v1.136h1.136v-1.136ZM14.772 18.93h-1.136v1.135h1.136V18.93ZM15.908 21.201v-1.136h-1.136v1.136h1.107v1.137h1.136V21.2h-1.107ZM21.588 15.521h-1.136v1.136h1.136v-1.136ZM19.316 14.47H18.18v2.187h1.136V14.47ZM20.452 13.334h-1.136v1.136h1.136v-1.136ZM19.316 16.657v1.136H18.18v1.136h2.272v-2.272h-1.136ZM20.452 23.417v-1.108h-1.136v-2.244H18.18v2.272h1.136v1.108h1.136v1.108h2.272v-1.136h-2.272Z' />
        <path d='M21.588 18.93h-1.136V21.2h1.136V18.93ZM25.905 20.037v-1.108h-2.073v1.136h-1.108v1.136h1.136v1.108h3.181v-2.272h-1.136Zm0 1.136H23.86v-1.108h2.045v1.108ZM27.041 23.417h-1.136v2.272h1.136v-2.272ZM22.724 21.201h-1.136v1.137h1.136V21.2ZM23.86 24.553h-1.136v1.136h1.136v-1.136ZM24.997 23.417H23.86v1.136h1.137v-1.136ZM23.86 25.689v2.187h1.137v-1.05h.908v-1.137H23.86ZM19.316 23.445H18.18v2.159h1.136v-2.159ZM21.588 26.74v-1.136h-2.272v2.272h1.136V26.74h1.108v1.136h1.136V26.74h-1.108ZM18.18 18.93h-2.272v1.135h2.272V18.93ZM13.636 20.065H12.5v2.273h1.136v-2.273Z' />
      </g>
      <defs>
        <clipPath id='a'>
          <path
            fill='#fff'
            transform='translate(12.5 13.334)'
            d='M0 0h14.542v14.542H0z'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export function ClassroomIcon() {
  return (
    <svg width='40' height='40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20Z'
        fill='#23A566'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20 37.218c9.509 0 17.218-7.71 17.218-17.218 0-9.509-7.71-17.217-17.218-17.217C10.491 2.783 2.783 10.49 2.783 20c0 9.509 7.708 17.218 17.217 17.218ZM20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z'
        fill='#F5BB16'
      />
      <path
        d='M26.792 20.453c1.042 0 1.888-.864 1.888-1.929 0-1.064-.846-1.928-1.888-1.928-1.042 0-1.888.864-1.888 1.928 0 1.065.846 1.929 1.888 1.929Zm0 1.286c-2.021 0-4.196 1.092-4.196 2.45v1.407h8.392v-1.407c0-1.358-2.175-2.45-4.196-2.45Zm-13.429-1.286c1.043 0 1.889-.864 1.889-1.929 0-1.064-.846-1.928-1.889-1.928-1.042 0-1.888.864-1.888 1.928 0 1.065.846 1.929 1.889 1.929Zm0 1.286c-2.02 0-4.196 1.092-4.196 2.45v1.407h8.393v-1.407c0-1.358-2.175-2.45-4.196-2.45Z'
        fill='#57BB8A'
      />
      <path
        d='M20.078 18.742c1.392 0 2.518-1.15 2.518-2.571 0-1.421-1.126-2.571-2.518-2.571s-2.518 1.15-2.518 2.571c0 1.422 1.126 2.572 2.518 2.572Zm0 1.715c-2.833 0-5.875 1.535-5.875 3.428V25.6h11.75v-1.715c0-1.893-3.043-3.428-5.875-3.428Z'
        fill='#F7F7F7'
      />
    </svg>
  )
}

export function TwitterIcon() {
  return (
    <svg width='40' height='40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20Z'
        fill='#1EA1F1'
      />
      <path
        d='M29.785 16.424a6.75 6.75 0 0 1-1.824.509c.327-.187.608-.433.841-.737.246-.304.427-.643.544-1.017a5.747 5.747 0 0 1-2 .772 2.882 2.882 0 0 0-1.034-.737 3.096 3.096 0 0 0-1.263-.263c-.573 0-1.099.146-1.578.438a3.136 3.136 0 0 0-1.561 2.719c0 .28.023.52.07.719a8.893 8.893 0 0 1-3.63-.982 8.98 8.98 0 0 1-2.86-2.315 3.194 3.194 0 0 0-.42 1.578c0 .538.123 1.04.368 1.508.257.456.602.83 1.035 1.123a2.86 2.86 0 0 1-1.42-.404v.053c0 .76.233 1.427.7 2a3.14 3.14 0 0 0 1.825 1.087c-.257.07-.538.105-.842.105-.21 0-.403-.017-.579-.052a3.085 3.085 0 0 0 1.105 1.56 3.085 3.085 0 0 0 1.824.614 6.008 6.008 0 0 1-1.824 1 6.256 6.256 0 0 1-2.087.35c-.152 0-.386-.011-.701-.034h-.053c1.462.935 3.075 1.403 4.84 1.403 1.392 0 2.672-.27 3.841-.807a8.523 8.523 0 0 0 2.807-2.105 9.409 9.409 0 0 0 1.719-2.876 9.02 9.02 0 0 0 .578-3.157v-.42a6.349 6.349 0 0 0 1.579-1.632Z'
        fill='#fff'
      />
    </svg>
  )
}
